


























helpers = require '../../helpers.coffee'

view_model = {
  data: ->
    seller_can_see_all_contacts: false
    seller_can_edit_templates: false
    seller_can_change_responsability: false
    company_id: Session.current_company.id
    company: null
    user: Session.current_user

  methods:
    toggleSellerCanChangeResponsability: ->
      @seller_can_change_responsability = !@seller_can_change_responsability

    toggleSellerCanSeeAllContacts: ->
      @seller_can_see_all_contacts = !@seller_can_see_all_contacts

    toggleSellerCanEditTemplates: ->
      @seller_can_edit_templates = !@seller_can_edit_templates

    loadCompany: ->
      Loader.on()
      new CompaniesResource().get(@loadCompanySuccess, @handleApiErrors, { id: @company_id })

    loadCompanySuccess: (data) ->
      @company = data.company
      @seller_can_see_all_contacts = @company.account_setting.seller_can_see_all_contacts
      @seller_can_edit_templates = @company.account_setting.seller_can_edit_templates
      @seller_can_change_responsability = @company.account_setting.seller_can_change_responsability
      Loader.off()

    updateCompany: ->
      if @company
        @company.account_setting.seller_can_see_all_contacts = @seller_can_see_all_contacts
        @company.account_setting.seller_can_edit_templates = @seller_can_edit_templates
        @company.account_setting.seller_can_change_responsability = @seller_can_change_responsability


    save: ->
      @updateCompany()
      if @company.account_setting.id
        Loader.on()
        new CompaniesResource().update( @saveSuccess, @handleApiErrors, @company.serialize() )
      else
        Loader.off()
        if @user.isManager()
          alertify.error 'Sua empresa ainda não foi vinculada a nenhum plano, por favor solicite a adesão.'
        else
          alertify.error 'A empresa em questão precisa estar vinculada a um plano para alterar permissões.'

    saveSuccess: ->
      Loader.off()
      Session.current_company.account_setting.seller_can_see_all_contacts = @seller_can_see_all_contacts
      Session.current_company.account_setting.seller_can_edit_templates = @seller_can_edit_templates
      Session.current_company.account_setting.seller_can_change_responsability = @seller_can_change_responsability
      alertify.success('Permissões atualizadas com sucesso')

  created:->
    @loadCompany()
}
exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/permissions.vue